import React from 'react';
import styled from 'styled-components';
import { TypographyComponent as TypographyElement } from '@tvg/fuse-design';

const LARGER_SCREENS = '22rem';
const SMALL_SCREENS = `calc(${LARGER_SCREENS} - 1px)`;

const Price = styled.span`
  color: var(--color-brand-mid);
`;

const ListContainer = styled.div`
  position: relative;
  margin: var(--spacing-space16) 0;

  &::after {
    content: '';
    display: block;
    position: absolute;
    background-color: var(--color-brand-mid);
  }

  @media (max-width: ${SMALL_SCREENS}) {
    display: inline-block;

    &::after {
      width: var(--spacing-space2);
      height: 100%;
      top: 0;
      left: 3.5rem;
      transform: translateX(-50%);
    }
  }

  @media (min-width: ${LARGER_SCREENS}) {
    display: block;

    &::after {
      width: 100%;
      height: var(--spacing-space2);
      top: 3.5rem;
      left: 0;
      transform: translateY(-50%);
    }
  }
`;

const List = styled.dl`
  display: flex;
  justify-content: space-between;
  margin: 0;

  @media (max-width: ${SMALL_SCREENS}) {
    flex-direction: column;
  }
`;

const ListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media (max-width: ${SMALL_SCREENS}) {
    flex-direction: row-reverse;

    &:not(:first-child) {
      margin-top: var(--spacing-space16);
    }
  }

  @media (min-width: ${LARGER_SCREENS}) {
    flex-direction: column-reverse;
  }
`;

const TermTitle = styled.dt`
  @media (max-width: ${SMALL_SCREENS}) {
    margin: 0 0 0 var(--spacing-space16);
  }

  @media (min-width: ${LARGER_SCREENS}) {
    margin: var(--spacing-space16) 0 0 0;
    text-align: center;
  }
`;

const TermAmount = styled.dd<{
  inactive?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 7rem;
  height: 7rem;
  margin: 0;
  z-index: 1;
  background: ${({ inactive }) => (inactive ? 'var(--color-global-grey300)' : 'var(--color-global-white)')};
  border: var(--spacing-space2) solid
    ${({ inactive }) => (inactive ? 'var(--color-global-grey300)' : 'var(--color-brand-mid)')};
  border-radius: 100%;
`;

interface Props {
  price: string;
  todaysPayment: string;
  firstPayment: string;
  secondPayment: string;
  thirdPayment: string;
}

function Take3Breakdown(props: Props) {
  const { price, todaysPayment, firstPayment, secondPayment, thirdPayment } = props;

  return (
    <>
      <TypographyElement tag="h3" size="4" type="heading">
        Spread the cost of <Price>{price}</Price> over 3 months
      </TypographyElement>

      <ListContainer>
        <List>
          <ListItem>
            <TermTitle>Today</TermTitle>
            <TermAmount inactive>
              <strong>{todaysPayment}</strong>
            </TermAmount>
          </ListItem>

          <ListItem>
            <TermTitle>
              1st <br aria-hidden="true" />
              Payment
            </TermTitle>
            <TermAmount>
              <strong>{firstPayment}</strong>
            </TermAmount>
          </ListItem>

          <ListItem>
            <TermTitle>
              2nd <br aria-hidden="true" />
              Payment
            </TermTitle>
            <TermAmount>
              <strong>{secondPayment}</strong>
            </TermAmount>
          </ListItem>

          <ListItem>
            <TermTitle>
              3rd <br aria-hidden="true" />
              Payment
            </TermTitle>
            <TermAmount>
              <strong>{thirdPayment}</strong>
            </TermAmount>
          </ListItem>
        </List>
      </ListContainer>
    </>
  );
}

export default Take3Breakdown;
